// @generated by TypeGen from LogbookModel/Status/EngineStatus.swift - DO NOT EDIT

export interface IEngineStatusData {
}

export enum IEngineStatus {
  off = 0,
  running = 1,
  idle = 2,
}
